"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequisitionAttachmentRequestDtoToJSON = exports.RequisitionAttachmentRequestDtoFromJSONTyped = exports.RequisitionAttachmentRequestDtoFromJSON = exports.instanceOfRequisitionAttachmentRequestDto = exports.RequisitionAttachmentRequestDtoReportResultEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.RequisitionAttachmentRequestDtoReportResultEnum = {
    Positive: 'Positive',
    PotentiallyPositive: 'Potentially positive',
    CarrierPotentiallyPositive: 'Carrier potentially positive',
    IncreasedRisk: 'Increased risk',
    Carrier: 'Carrier',
    Uncertain: 'Uncertain',
    Negative: 'Negative',
    NegativePartial: 'Negative partial',
    Indeterminate: 'Indeterminate',
    Other: 'Other'
};
/**
 * Check if a given object implements the RequisitionAttachmentRequestDto interface.
 */
function instanceOfRequisitionAttachmentRequestDto(value) {
    var isInstance = true;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "signee" in value;
    return isInstance;
}
exports.instanceOfRequisitionAttachmentRequestDto = instanceOfRequisitionAttachmentRequestDto;
function RequisitionAttachmentRequestDtoFromJSON(json) {
    return RequisitionAttachmentRequestDtoFromJSONTyped(json, false);
}
exports.RequisitionAttachmentRequestDtoFromJSON = RequisitionAttachmentRequestDtoFromJSON;
function RequisitionAttachmentRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'category': json['category'],
        'contentType': !(0, runtime_1.exists)(json, 'content_type') ? undefined : json['content_type'],
        'data': json['data'],
        'documentId': !(0, runtime_1.exists)(json, 'document_id') ? undefined : json['document_id'],
        'name': json['name'],
        'positiveFinding': !(0, runtime_1.exists)(json, 'positive_finding') ? undefined : json['positive_finding'],
        'requisitionId': !(0, runtime_1.exists)(json, 'requisition_id') ? undefined : json['requisition_id'],
        'signee': json['signee'],
        'ar': !(0, runtime_1.exists)(json, 'ar') ? undefined : json['ar'],
        'reportResult': !(0, runtime_1.exists)(json, 'report_result') ? undefined : json['report_result'],
        'isSharedWithPhysician': !(0, runtime_1.exists)(json, 'is_shared_with_physician') ? undefined : json['is_shared_with_physician'],
    };
}
exports.RequisitionAttachmentRequestDtoFromJSONTyped = RequisitionAttachmentRequestDtoFromJSONTyped;
function RequisitionAttachmentRequestDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'category': value.category,
        'content_type': value.contentType,
        'data': value.data,
        'document_id': value.documentId,
        'name': value.name,
        'positive_finding': value.positiveFinding,
        'requisition_id': value.requisitionId,
        'signee': value.signee,
        'ar': value.ar,
        'report_result': value.reportResult,
        'is_shared_with_physician': value.isSharedWithPhysician,
    };
}
exports.RequisitionAttachmentRequestDtoToJSON = RequisitionAttachmentRequestDtoToJSON;
